import { observer } from 'mobx-react';
import { logoIcon } from '../../assets';
import strings from '../../localization';
import './index.css';


const VestelHeader = ({ children }) => {
  return <div className="vestel-header">
    <div className="vestel-header-left">
      <img src={logoIcon} alt="logo" className="vestel-header-left-logo" />
      <span className="vestel-header-left-title">{strings.remoteSupportPlatform}</span>
    </div>
    {children}
  </div>;
};

export default observer(VestelHeader);